import { Label, Layout} from "@mcleod/components";

export abstract class AutogenLayoutContinuousMove extends Layout {
  labelResponse: Label;
}
